import PageHeader from 'components/common/PageHeader/PageHeader';
import Tabs from 'components/common/Tabs/Tabs';
import TabbedPageHeader from 'components/common/TabbedPageHeader/TabbedPageHeader';
import Toolbar from 'components/common/Toolbar/Toolbar';
import Button, { ButtonVariant } from 'components/common/Button/Button';

/**
 * Examples of Scalyr's Page Header component
 */

function PageHeaderExamplePage(): JSX.Element {
  const ALERT_TABS = {
    TRIGGERED: 'triggered',
    MUTED: 'muted',
    ALL: 'all',
  };
  const tabs = [
    { title: 'Triggered', eventKey: ALERT_TABS.TRIGGERED },
    { title: 'Muted', eventKey: ALERT_TABS.MUTED },
    { title: 'All', eventKey: ALERT_TABS.ALL },
  ];

  const button1 = <Button href="#">Action</Button>;
  const button2 = (
    <Button href="#" variant={ButtonVariant.PRIMARY}>
      Main Action
    </Button>
  );
  const headerItems = [button1, button2];

  return (
    <section id="pageHeader" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Page Header</h1>
      <div className="ExamplesPage__Subhead mb-2">Standard Page Header</div>
      <div className="ExampleBox">
        <PageHeader title="Page Title" helpLink="#" />
      </div>
      <div className="ExamplesPage__Subhead mb-2 mt-5">Tabbed Page Header</div>
      <div className="ExampleBox">
        <Tabs defaultActiveTab={ALERT_TABS.TRIGGERED}>
          <TabbedPageHeader
            title="Page Title"
            tabs={tabs}
            headerItems={[<Toolbar items={headerItems} key="PageHeaderExamplePage" />]}
          />
        </Tabs>
      </div>
    </section>
  );
}
export default PageHeaderExamplePage;
